import { useEffect } from "react";

interface UseClickOutsideParams {
  ref: React.RefObject<HTMLDivElement>;
  isActive: boolean;
  onClickOutside: () => void;
}

export function useClickOutside({ ref, isActive, onClickOutside }: UseClickOutsideParams) {
  useEffect(() => {
    if (!isActive) {
      return;
    }

    const handleMouseDown = (event: MouseEvent) => {
      if (!ref.current?.contains(event.target as Node)) {
        onClickOutside();
      }
    };

    document.addEventListener("mousedown", handleMouseDown);
    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, [isActive, ref, onClickOutside]);
}
